import template from './genderSelection.tpl';
import BaseStep from './../BaseStep';
import StepEvent from './../StepEvent';
import EventDispatcher from '@/core/event/eventDispatcher';
import AppStateModel from '../../../../model/appStateModel';
import MainController from '../../../../controller/MainController';
import  {gsap} from 'gsap';

import male from '@/assets/images/male.svg?raw';
import female from '@/assets/images/female.svg?raw';

class GenderSelection extends BaseStep {

    constructor(id, data) {
        super(id, data);
        let assets:{male: string, female: string} = {
            male: male,
            female: female
        }
        this._template = template({data: this._data, assets: assets});

    }


    select(item) {

        let target = item.getAttributeNode('data-target').value;
        //let target = item.dataset.target;

        let gender = item.getAttributeNode('data-gender').value;
        //let gender = item.dataset.gender;


        let data = {
            input: gender,
            next_step: target,
            id: this._id
        };

        AppStateModel.gender = gender;

        if (target) {
            EventDispatcher.dispatchEvent(new StepEvent(StepEvent.STEP_FINISHED, data));
        }
    }


    render() {
        super.render();

        if (this.element) {
            let selectors = this.element.querySelectorAll('.gender_selector');

            for (let item of selectors) {
                item.addEventListener('click', () => this.select(item));
            }
        }
        return this.element;
    }

    postRender() {
        this.setAnimationElements();

        // disable sharing for this view/step
        MainController.setSharing(false);
    }

    setAnimationElements() {
        if (this.element) {
            this.animationElements = {
                fButton: this.element.querySelectorAll('.woman_selector'),
                mButton: this.element.querySelectorAll('.men_selector'),
                question: this.element.querySelectorAll('.question')
            }
        }
    }

    getHideAnimation() {
        let animations: any[] = [];

        let a = this.animationElements;

        if (AppStateModel.gender === 'm') {
            // select "male"
            animations.push(gsap.to(a.mButton, 1.2, {right: '25%', transform: 'rotate(-20deg)'}));
            animations.push(gsap.to(a.mButton, 0.5, {delay: 0.5, autoAlpha: 0, display: 'none'}));
            animations.push(gsap.to(a.fButton, 0.15, {autoAlpha: 0, display: 'none', right: '15%'}));

            // question text:
            animations.push(gsap.to(a.question, 0.5, {right: '20%'}));
            animations.push(gsap.to(a.question, 0.3, {autoAlpha: 0, display: 'none'}));
        } else {
            // select "female"
            animations.push(gsap.to(a.fButton, 1.2, {left: '25%', transform: 'rotate(-20deg)'}));
            animations.push(gsap.to(a.fButton, 0.5, {delay: 0.5, autoAlpha: 0, display: 'none'}));
            animations.push(gsap.to(a.mButton, 0.15, {autoAlpha: 0, display: 'none', left: '15%'}));

            // question text:
            animations.push(gsap.to(a.question, 0.5, {left: '20%'}));
            animations.push(gsap.to(a.question, 0.3, {autoAlpha: 0, display: 'none'}));
        }

        return animations;
    }

    getShowAnimation() {
        let animations: any[] = [];

        //add tweens to animations.

        return animations;
    }


}

export default GenderSelection;
